import { priceSourcesApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';

// LEN-259 phase 6: a source's reading-template versions are read by the card or review that shows
// them, so these thunks return the data and keep nothing in the store.
const TEMPLATE_HISTORY_TAKE = 10;

const isNotFound = error => error?.response?.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND;

export const readPriceSourceTemplatesAction = priceSourceId => async () => {
  const { data } = await priceSourcesApi.getTemplates(priceSourceId, {
    take: TEMPLATE_HISTORY_TAKE,
  });

  return data ?? [];
};

// 404 means the source has no Active reading template yet, which is not an error.
export const readActivePriceSourceTemplateAction = priceSourceId => async () => {
  try {
    const { data } = await priceSourcesApi.getActiveTemplate(priceSourceId);

    return data ?? null;
  } catch (error) {
    if (isNotFound(error)) {
      return null;
    }

    throw error;
  }
};
